import ProfileImage from "common/components/ui/ProfileImage";
import type { WorkspaceAccount } from "common/types";

import type { ComponentProps, ReactNode } from "react";

import DisconnectedIcon from "assets/icons/disconnected.svg?react";
import LicenseIcon from "assets/icons/license.svg?react";
import RentedIcon from "assets/icons/rented.svg?react";

interface AccountProfileImageProps {
  account: WorkspaceAccount;
  size?: ComponentProps<typeof ProfileImage>["size"];
}

export default function AccountProfileImage({
  account,
  size = "md",
}: AccountProfileImageProps) {
  const {
    state,
    license,
    picture_url: pictureUrl,
    full_name: fullName,
    type,
  } = account;

  let icon: ReactNode;

  if (type === "rental") {
    icon = <RentedIcon />;
  } else if (state === "LoggedOut") {
    icon = <DisconnectedIcon />;
  } else if (license) {
    icon = <LicenseIcon />;
  }

  const profileImageComponent = (
    <ProfileImage
      src={pictureUrl}
      aria-label="Account profile image"
      size={size}
      alt={fullName}
    />
  );

  if (icon) {
    return (
      <div className="shrink-0 relative [&>svg]:absolute [&>svg]:-bottom-0.5 [&>svg]:-right-0.5">
        {profileImageComponent} {icon}
      </div>
    );
  }

  return profileImageComponent;
}
